import React from 'react'
import { useTranslation } from 'react-i18next';
import Container from '../../container/container'
import rseStyles from './rse.module.scss';




export default function RSE() {

    const { t, i18n } = useTranslation();


    return (
        <Container>
            < h1 className={` title `}>{t('rse')}</h1>
            <p className='rseStyles.p'>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Animi, dicta quas. Esse, autem porro recusandae reprehenderit provident doloremque molestias dignissimos voluptas ullam ex fuga dolor, magni tenetur iure adipisci tempore obcaecati, nihil odio voluptatum veniam atque consequatur? Impedit ab explicabo, reprehenderit ipsum a adipisci odit exercitationem commodi suscipit aut hic porro odio? Explicabo quisquam amet qui delectus ullam obcaecati inventore fuga exercitationem aperiam a beatae adipisci voluptatibus minus, pariatur quidem laboriosam et. Laboriosam vero optio cupiditate incidunt corporis ad dicta, quam sint blanditiis atque perferendis recusandae ullam, laborum est odio eum veniam? Illum, odio! Atque animi error consequuntur deserunt commodi.</p>
        </Container>

    )
}
